import { render, staticRenderFns } from "./FormOfPaymentListServerSide.vue?vue&type=template&id=f0bce214"
import script from "./FormOfPaymentListServerSide.vue?vue&type=script&lang=js"
export * from "./FormOfPaymentListServerSide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports